<template>
    <div class="sign-board">
        <div v-if="isTitle" class="sign-title">
            簽名：
        </div>
        <div ref="signBtn" class="sign-btns h-align" >
            <span v-if="value" id="save" class="default-button" v-on:click="saveAsImg">保存簽名</span>
            <span v-if="value" id="clear"  v-on:click="canvasClear()">清空</span>
            <span v-if="type === 'SETTING' && signatureImage" id="save" class="border-button" v-on:click="signatureImage=null">重新簽名</span>
            <span v-if="type === 'CONTRACT' && autoSign && signatureImage" id="save" class="border-button" v-on:click="signatureImage=null">重新簽名</span>
            <a v-if="isSign" href="/enterprise/personalCenter/" target="_blank" rel="noopener noreferrer">
                <span id="setting">
                    簽名設定
                    <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="">
                </span>
            </a>
        </div>
        <div class="wrap" v-if="isSave" :class="{'is-save': isSave}">
            <img :src="value" alt="">
        </div>
        <div class="wrap" v-else>
            <img v-if="type === 'SETTING' && signatureImage" class="sign-canvas" :src="signatureImage" alt="" srcset="">
            <img v-else-if="type === 'CONTRACT' && autoSign && signatureImage" class="sign-canvas" :src="signatureImage" alt="" srcset="">
            <sign-canvas v-else class="sign-canvas" ref="SignCanvas" :options="options" v-model="value"/>
        </div>
    </div>
</template>
<script>
import SignCanvas from 'sign-canvas';
import { 
    apiBizUploadSignature,
    apiBizGetSignatureImg,
    } from "@/apis/api.js"; 
import { mapGetters } from 'vuex'

export default {
    data(){
        return {
            value: null,
            isSave: false,
            signatureImage: null,
            options:{
                isDpr: false,       //是否使用dpr兼容高倍屏 [Boolean] 可选
                lastWriteSpeed: 1,  //书写速度 [Number] 可选
                lastWriteWidth: 2,  //下笔的宽度 [Number] 可选
                lineCap: 'round',   //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
                lineJoin: 'bevel',  //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                canvasWidth: 400, //canvas宽高 [Number] 可选
                canvasHeight: 200,  //高度  [Number] 可选
                isShowBorder: false, //是否显示边框 [可选]
                bgColor: '#f6f6f6', //背景色 [String] 可选
                borderWidth: 1, // 网格线宽度  [Number] 可选
                writeWidth: 5, //基础轨迹宽度  [Number] 可选
                maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
                minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                writeColor: '#292625', // 轨迹颜色  [String] 可选
                isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                imgType:'png'   //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
            }
        }
    },
    props: {
        isTitle: {
            type: Boolean,
            default: true
        },
        isSign: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'CONTRACT'
        }
    },
    mounted() {
        this.$store.dispatch('bizGetUserInfo')
        .then(() => {
            this.getSignature()
        })
    },
    methods:{
        /**
         * 清除画板
         */
        canvasClear(){
            this.$refs.SignCanvas.canvasClear();
        },

        /**
         * 保存图片
         */
        saveAsImg(){
            let _self = this
            const img = this.$refs.SignCanvas.saveAsImg();
            if(this.type === 'CONTRACT'){
                _self.$store.dispatch('setSignData',{type: 'sign', value: img})
                .then( () => {
                    // _self.$refs.signBtn.style.display = 'none'
                    _self.isSave = true
                })
            }else{
                let formData = new FormData();
                formData.append('account', this.userAccount);
                formData.append('signature', this.value);
                formData.append('check', false);
                apiBizUploadSignature(formData)
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        _self.isSave = true
                    }
                })
            }
            
        },
        getSignature: function () {
            let _self = this
            apiBizGetSignatureImg('SIGNATURE')
            .then(res => {
                if(res.status == 200){
                    console.log(res)
                    if(res.data){
                        let image = 'data:image/png;base64,'+res.data
                        _self.signatureImage = image
                        if(this.type === 'CONTRACT'){
                            _self.$store.dispatch('setSignData',{type: 'sign', value: image})
                        }
                    }
                }
            })
            .catch(err => {
            })
        },
    },
    computed: {
        ...mapGetters({
            autoSign: 'GET_BIZ_USER_AUTO_SIGN',
            userAccount: 'GET_BIZ_USER_ACCOUNT',
        })
    },
    components: {
        SignCanvas,
    }
}
</script>
<style lang="scss">
.sign-board{
    .sign-title{
        font-size: 14px;
    }
    .sign-btns{
        display: flex;
        align-items: center !important;
        justify-content: flex-end !important;
        width: 100%;
        height: 32px;
        margin-bottom: 10px;
        #clear{
            cursor: pointer;
            width: 72px;
            height: 32px;
            border-radius: 4px;
            background-color: #fff9f1;
            color: #eb7859;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            margin-left: 8px;
        }
        #save{
            cursor: pointer;
            width: 72px;
            height: 32px;
            margin-left: 8px;
        }
        #setting{
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 92px;
            height: 32px;
            border: solid 1px #e0dfde;
            background-color: #ffffff;
            cursor: pointer;
            margin-left: 8px;
            >img{
                width: 24px;
            }
        }
    }
    .wrap{
        display: flex;
        width: 400px;
        height: 200px;
        >img{
            width: 100%;
        }
        &.is-save{
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            border: solid 1px #fc7171;
            // margin-right: 12px;
            width: 100px;
            height: 100px;
            background: #f6f6f6;
            width: 400px;
            height: 200px;
        }
        .sign-canvas{
            display: block;
            border-radius: 6px;
            border: solid 1px #e0dfde;
            background-color: #f6f6f6;
            justify-content: center;
            color: #a09896;
            overflow: hidden;
        }
    }
    
}

</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/bookingMgt/bizContract/signBoard.vue